export default __webpack_public_path__ + "static/media/quantisal_step3.84835a9e.png";